/** Refine AuthBindings — login, logout, check, getIdentity, getPermissions. */

import type { AuthBindings } from "@refinedev/core";

import { api } from "@/lib/api";
import { useAuthStore } from "@/stores/auth";

export const authProvider: AuthBindings = {
  async login({ email, password }) {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      useAuthStore.getState().setSession(data.csrf_token);
      useAuthStore.getState().setUser(data.user);
      return { success: true, redirectTo: "/" };
    } catch (e: any) {
      const errMsg =
        e?.response?.data?.error?.message ?? "Неверный email или пароль";
      return {
        success: false,
        error: { name: "Login failed", message: errMsg },
      };
    }
  },

  async logout() {
    try {
      await api.post("/auth/logout", {});
    } catch {
      // ignore network errors during logout
    }
    useAuthStore.getState().logout();
    return { success: true, redirectTo: "/login" };
  },

  async check() {
    const { user, csrfToken } = useAuthStore.getState();
    if (user) {
      return { authenticated: true };
    }

    // Токены в httpOnly-куках JS не видит — единственный сигнал "залогинен" это
    // сам API. Без csrf-токена и следов старой сессии не дёргаем /me впустую.
    if (!csrfToken && !localStorage.getItem("ri-admin-auth")) {
      return { authenticated: false, redirectTo: "/login" };
    }

    try {
      const { data } = await api.get("/me");
      useAuthStore.getState().setUser(data);
      return { authenticated: true };
    } catch {
      useAuthStore.getState().logout();
      return { authenticated: false, redirectTo: "/login" };
    }
  },

  async getIdentity() {
    return useAuthStore.getState().user;
  },

  async getPermissions() {
    return useAuthStore.getState().user?.role;
  },

  async onError(error) {
    if (error?.response?.status === 401) {
      return { logout: true, redirectTo: "/login" };
    }
    return {};
  },
};
